import { ROUTING_PATHS } from 'const';
import { NoPlannedSessionsPlaceholder } from './NoPlannedSessionsPlaceholder';
import { useLrwSessions } from './useLrwSessions';
import { LrwSessionsFilterBar } from './LrwSessionsFilterBar';
import { BreadcrumbsActionsPortal, DebouncedFullScreenLoader } from 'components';
import { useAllowedActions } from 'hooks';
import { Link, generatePath } from 'react-router';
import { Button, Icon, SuiTable } from '@britishcouncil/react-admin';
import { columns } from './columns';
import styled from '@emotion/styled';

export const LrwSessions = () => {
  const { createLrwSession } = ROUTING_PATHS;
  const {
    lrwSessions,
    isFetching,
    isLoading,
    onTableStateChange,
    tableState,
    venues,
    onFiltersApply,
    hasActiveFilters,
  } = useLrwSessions();
  const { canCreateLrwSession } = useAllowedActions();

  if (!lrwSessions) return <DebouncedFullScreenLoader isFetching={isLoading} />;

  return (
    <>
      <BreadcrumbsActionsPortal>
        {canCreateLrwSession && (
          <S.CreateLink to={generatePath(createLrwSession.absolutePath)}>
            <Button compact primary data-testid="create-lrw-session-button">
              <Icon name="plus square" />
              Create
            </Button>
          </S.CreateLink>
        )}
      </BreadcrumbsActionsPortal>
      <S.FilterBarWrapper>
        <LrwSessionsFilterBar venues={venues} onFiltersApply={onFiltersApply} />
      </S.FilterBarWrapper>
      {!lrwSessions.results?.length && !hasActiveFilters ? (
        <NoPlannedSessionsPlaceholder />
      ) : (
        <S.TableWrapper>
          <SuiTable
            columns={columns}
            data={lrwSessions.results ?? []}
            state={tableState}
            totalCount={lrwSessions.totalCount}
            onStateChange={onTableStateChange}
            loading={isFetching}
            disableFilters
            pageSizes={[10, 25, 50, 100]}
            attached
            tableProps={{ 'data-testid': 'lrw-sessions-list' }}
          />
        </S.TableWrapper>
      )}
    </>
  );
};

const S = {
  FilterBarWrapper: styled.div`
    margin-bottom: 1rem;
  `,
  TableWrapper: styled.div`
    & > .ui.segment.attached {
      width: 100%;
    }
  `,
  CreateLink: styled(Link)`
    margin-right: 1rem;
  `,
};
